import { render, staticRenderFns } from "./AcoesUtilizacao.vue?vue&type=template&id=fd97a2c8&scoped=true"
import script from "./AcoesUtilizacao.vue?vue&type=script&lang=js"
export * from "./AcoesUtilizacao.vue?vue&type=script&lang=js"
import style0 from "./AcoesUtilizacao.vue?vue&type=style&index=0&id=fd97a2c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd97a2c8",
  null
  
)

export default component.exports